import api from "./api-manager";

const { REACT_APP_API_A39, REACT_APP_RMP_APP_ID } = process.env;

export default {
  async getFacebookSettings(params) {
    return api.get(`/v1/facebook/settings`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  async setFacebookSettings(params) {
    return api.post(
      `/v1/facebook/settings`,
      {
        fbBusinessId: params.fbBusinessId,
        fbBusinessName: params.fbBusinessName,
        fbAdsId: params.fbAdsId,
        fbAdsName: params.fbAdsName,
        fbPixelCodeId: params.fbPixelCodeId,
        setupStatus: params.setupStatus,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async setFacebookConversionStatus(params) {
    return api.post(
      `/v1/facebook/settings/conversion-status`,
      {
        fbConversionStatus: params.fbConversionStatus,
        conversionType: params.conversionType,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async setFacebookConversionSettingStatus(params) {
    return api.post(
      `/v1/facebook/conversions/status`,
      {
        conversionStatus: params.conversionStatus,
        conversionType: params.conversionType,
        pipelineId: params.pipelineId,
        pipelineSteps: params.pipelineSteps,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async getFacebookConversionLastSent(params) {
    return api.get(`/v1/facebook/conversions/last-sent`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  async getFacebookCRMConversionLastSent(params) {
    return api.get(`/v1/facebook/conversions/crm-conversion/last-sent`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  async getFacebookConversionSettingByPipeline(params) {
    return api.get(`/v1/facebook/conversions/pipeline/${params.pipelineId}`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  async getFacebookGraphBusinessOwnedAdsAccounts(params) {
    return api.post(
      `/v1/facebook/graph/business/${params.fbBusinessId}/owned-ads-accounts`,
      {
        userAccessToken: params.userAccessToken,
        searchQuery: params.searchQuery || "",
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },

  async rwidgetConversionDefaultValue(params) {
    return api.post(
      `/v1/rwidget/conversions/default-value`,
      {
        ...params,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },

  async getRwidgetConversionDefaultValue(params) {
    return api.get(`/v1/rwidget/conversions/get-default-value`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },

  /**
   * get facebook page id and page access token
   * @param {*} params
   * @returns
   */
  async getFacebookPageId(params) {
    return api.post(
      `/v1/facebook/get-page-id`,
      {
        userAccessToken: params.userAccessToken,
        pageUrl: params.pageUrl,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },

  /**
   * get list of facebook lead forms by page access token and page url/id
   * @param {*} params
   * @returns
   */
  async getFacebookFormList(params) {
    return api.post(
      `/v1/facebook/get-lead-forms-list`,
      {
        pageAccessToken: params.pageAccessToken,
        pageId: params.pageUrl,
        appReserve: params.appReserve,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },

  /**
   * get all lead form settings to show all connections
   * @param {*} params
   * @returns
   */
  async getAllLeadFormSettings(params) {
    return api.post(
      `/v1/facebook/get-all-lead-form-setting`,
      { appReserve: params.appReserve },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save facebook account to database (facebook_account table)
   * @param {*} params
   * @returns
   */
  async setFacebookAccount(params) {
    return api.post(
      `/v1/facebook/save-account`,
      {
        userAccessToken: params.userAccessToken,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook account data from database
   * @param {*} params
   * @returns
   */
  async getFacebookAccount(params) {
    return api.post(
      `/v1/facebook/get-account`,
      {
        userId: params.userId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * set user_status value to database
   * @param {*} params
   * @returns
   */
  async switchLeadFormStatus(params) {
    return api.post(
      `/v1/facebook/swich-lead-form-status`,
      {
        facebookLeadSettingId: params.facebookLeadSettingId,
        status: params.status,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get data about facebook lead form setting in modal (edit)
   * @param {*} params
   * @returns
   */
  async getLeadFormSetting(params) {
    return api.post(
      `/v1/facebook/get-lead-form-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get data about facebook setting in modal (edit)
   * @param {*} params
   * @returns
   */
  async getFacebookPageSetting(params) {
    return api.post(
      `/v1/facebook/get-facebook-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get data about google setting in modal (edit)
   * @param {*} params
   * @returns
   */
  async getGoogleSetting(params) {
    return api.post(
      `/v1/facebook/get-google-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get data about rcrm setting in modal (edit)
   * @param {*} params
   * @returns
   */
  async getCRMSetting(params) {
    return api.post(
      `/v1/facebook/get-crm-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save facebook lead form setting to database
   * @param {*} params
   * @returns
   */
  async setLeadFormSetting(params) {
    return api.post(
      `/v1/facebook/save-settings-lead-form`,
      {
        settingId: params.settingId,
        pageUrl: params.pageUrl,
        formSetting: params.formSetting,
        formId: params.formId,
        fbUserId: params.fbUserId,
        appReserve: params.appReserve,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get page setting by pageUrl
   * @param {*} params
   */
  async getPageSetting(params) {
    return api.post(
      `/v1/facebook/get-page-setting`,
      {
        pageUrl: params.pageUrl,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook user info
   * @param {*} params
   */
  async getFacebookUserInfo(params) {
    return api.post(
      `/v1/facebook/get-user-info`,
      {
        userAccessToken: params.userAccessToken,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get new access token
   * @param {*} params
   */
  async getFacebookNewAccessToken(params) {
    return api.post(
      `/v1/facebook/get-access-token-expires-facebook-api`,
      {
        userAccessToken: params.userAccessToken,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook page access token
   * @param {*} params
   */
  async getFacebookPageAccessToken(params) {
    return api.post(
      `/v1/facebook/get-page-access-token`,
      {
        userId: params.userId,
        pageId: params.pageId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook page by fb_account_id
   * @param {*} params
   */
  async getFacebookPageByUserId(params) {
    return api.post(
      `/v1/facebook/get-page-by-user`,
      {
        userId: params.userId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * delete leadform setting
   * @param {*} params
   * @returns
   */
  async archiveLeadFormSetting(params) {
    return api.post(
      `/v1/facebook/archive-lead-form-setting`,
      {
        id: params.id,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook page list
   * @param {*} params
   * @returns
   */
  async getFacebookPageList(params) {
    return api.post(
      `/v1/facebook/list-page`,
      {
        userAccessToken: params.userAccessToken,
        loadMore: params.loadMore,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get user access token from database
   * @param {*} params
   * @returns
   */
  async getUserAccessToken(params) {
    return api.post(
      `/v1/facebook/get-user-access-token`,
      {
        userId: params.userId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get facebook page list more
   * @param {*} params
   * @returns
   */
  async getFacebookPageListMore(params) {
    return api.post(
      `/v1/facebook/list-page`,
      {
        userAccessToken: params.userAccessToken,
        loadMore: params.loadMore,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get google sheets crm conversion last send time
   * @param {*} params
   */
  async getGoogleSheetsCRMConversionsLastSend(params) {
    return api.get(`/v1/facebook/gsheet/conversions/last-sent`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  /**
   * get detail of pixel id
   * @param {*} params
   * @returns
   */
  async getDetailsPixelId(params) {
    return api.get(`/v1/facebook/get-details-pixel`, {
      baseURL: REACT_APP_API_A39,
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });
  },
  /**
   * update error status and error message of facebook lead form setting
   * @param {*} params
   * @returns
   */
  async updateFBLeadFormSettingErrorStatus(params) {
    return api.post(
      `/v1/facebook/update-error-status`,
      {
        facebookLeadSettingId: params.facebookLeadSettingId,
        connectedApp: params.connectedApp,
        errorMessage: params.errorMessage,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
